<template>
    <div class="HotWaterTableSummarized">
        <div class="flex-column">
            <div style="width: 100%; height: calc(100vh - 40px)">
                <DxDataGrid ref="HotWaterTableSummarizedList"
                            :data-source="dataSource"
                            :column-auto-width="true"
                            :row-alternation-enabled="true"
                            :allow-column-resizing="true"
                            :show-row-lines="true"
                            :show-borders="true"
                            :columns="columns"
                            @initialized="onInitialized"
                            @toolbar-preparing="onToolbarPreparing"
                            height="100%">

                    <DxPaging :page-size="500" />
                    <DxPager :visible="false" />
                    <DxFilterRow :visible="true"
                                 apply-filter="auto" />

                    <DxScrolling show-scrollbar="always"
                                 column-rendering-mode="standard"
                                 row-rendering-mode="standard"
                                 :mode="'virtual'"
                                 :preload-enabled="false" />

                    <template #title-header="{ data }">
                        <div class="d-flex">
                            <div class="flex-1 text-left">{{ data.column.caption }}</div>
                        </div>
                    </template>

                    <template #idColumnTemplate="{ data: cellInfo }">
                        {{ rowId(cellInfo) }}
                    </template>

                    <template #validColumnHeader="{ data }">
                        <i class="dx-icon-warning warning-icon-header"></i>
                    </template>

                    <template #backbtn="{ data }">
                        <div>
                            <DxBtn name="back"
                                   hint="Vissza a feltöltésekhez"
                                   text="Vissza"
                                   icon="back"
                                   @click="backbtn" />
                        </div>
                    </template>

                    <template #uploadFile="{ data }">
                        <div>
                            <DxBtn name="upload"
                                   hint="Fájl feltöltés"
                                   text="Fájl feltöltés"
                                   icon="upload"
                                   @click="importBtnClick" />

                            <form style="display:none;">
                                <input type="file" id="fileupload" name="files" accept=".xml" @change="importFile" />
                            </form>
                        </div>
                    </template>

                </DxDataGrid>
            </div>
        </div>
    </div>
</template>

<script>
    import DxList from "devextreme-vue/list";
    import HotWaterTableSummarizedService from "../services/HotWaterTableSummarized.service";
    import DxForm, {
        DxItem as DxFormItem,
        DxButtonItem,
        DxLabel
    } from "devextreme-vue/form";
    import DxPopup, {
        DxToolbarItem as DxPopupToolbarItem
    } from "devextreme-vue/popup";
    import DxToolbar, { DxItem as DxToolbarItem } from "devextreme-vue/toolbar";
    import DxSelectBox from "devextreme-vue/select-box";
    import DxDataGrid, {
        DxGrouping,
        DxGroupPanel,
        DxSearchPanel,
        DxPaging,
        DxPager,
        DxSorting,
        DxScrolling,
        DxFilterRow,
        DxColumn,
        DxEditing,
        DxLookup,
        DxRequiredRule,
        DxPopup as DxDataGridEditPopup,
        DxPosition,
        DxForm as DxDatagridEditForm,
        DxButton,
        DxColumnFixing,
        DxRowDragging
    } from "devextreme-vue/data-grid";
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import CustomStore from "devextreme/data/custom_store";
    import { DxButton as DxBtn } from 'devextreme-vue/button';
    import notify from "devextreme/ui/notify";
    import { DxLoadPanel } from 'devextreme-vue/load-panel';

    export default {
        name: 'HotWaterTableSummarized',
        components: {
            DxPopup,
            DxFormItem,
            DxButtonItem,
            DxLabel,
            DxForm,
            DxToolbarItem,
            DxPopupToolbarItem,
            DxSelectBox,
            DxList,
            DxGrouping,
            DxGroupPanel,
            DxSearchPanel,
            DxPaging,
            DxPager,
            DxSorting,
            DxScrolling,
            DxFilterRow,
            DxColumn,
            DxEditing,
            DxLookup,
            DxRequiredRule,
            DxPosition,
            DxDatagridEditForm,
            DxButton,
            DxDataGridEditPopup,
            DxColumnFixing,
            DxRowDragging,
            DxDataGrid,
            DxScrollView,
            DxToolbar,
            DxBtn,
            DxLoadPanel
        },
        data() {
            return {
                columns: [],
                datagrid: null,
                dataSource: new CustomStore({
                    key: "id",
                    load: () => {
                        return HotWaterTableSummarizedService.get(this.$router.currentRoute.params.id).then(result => {
                            let rows = [];
                            let id = 1;

                            for (let key in result) {
                                let item = result[key];
                                let row = { id: id, customerId: item.customerId, name: item.name };

                                item.acus.forEach(acu => {
                                    row[acu.key] = acu.value;
                                });

                                rows.push(row);
                                id++;
                            };

                            return rows;
                        });
                    },
                    insert: (values) => {
                        return HotWaterTableSummarizedService.insert(values);
                    },
                    update: (key, values, reorder) =>
                        HotWaterTableSummarizedService.update({
                            key: key,
                            values: JSON.stringify(values),
                            reorder: values.hasOwnProperty('OrderIndex')
                        }),
                    remove: key => HotWaterTableSummarizedService.delete(key)
                }),
            };
        },
        methods: {
            onInitialized(e, level) {
                this.datagrid = e.component;
                this.getColumns();
            },
            rowId: function (cellInfo) {
                return cellInfo.row.rowIndex + 1;
            },
            onToolbarPreparing(e) {
                e.toolbarOptions.items.unshift({
                    location: 'before',
                    template: 'backbtn'
                });
            },
            backbtn() {
                this.$router.push('/heatcalculator');
            },
            getColumns() {
                let defaultColumns = [
                    {
                        dataField: 'id',
                        alignment: 'center',
                        width: '50px',
                        cellTemplate: 'idColumnTemplate',
                        allowEditing: 'false',
                    },
                    {
                        dataField: 'customerId',
                        caption: 'Ügyfél-azonosító',
                        allowEditing: 'false',
                        alignment: 'left',
                        width: '150px',
                    },
                    {
                        dataField: 'name',
                        caption: 'Díjfizető neve',
                        allowEditing: 'false',
                        alignment: 'left',
                        width: '300px',
                    }
                ];


                HotWaterTableSummarizedService.getColumns().then(result => {
                    this.columns = defaultColumns.concat(result);
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    #mapScrollview {
        height: 100%;
    }
    ::v-deep .grid {
        fill-opacity: 0;
    }
    ::v-deep .dx-scrollable {
        width: 100%;
    }

    ::v-deep .dx-scrollable-content {
        padding-bottom: 0 !important;
    }

    ::v-deep .dx-datagrid-header-panel .dx-toolbar {
        padding: 10px 10px 0px 10px;
    }

    ::v-deep .dx-datagrid-edit-popup .dx-state-readonly {
        border: none !important;
    }

    .positionid {
        display: block;
        float: left;
        width: 19px;
        text-align: right;
        margin-right: 3px;
    }
    ::v-deep .dx-datagrid, ::v-deep .dx-toolbar {
        background-color: transparent;
    }
    ::v-deep .dx-toolbar-text-auto-hide .dx-button .dx-icon {
        line-height: 20px;
    }
    .warning-icon {
        font-size: 18px;
        color: #ff0000;
        vertical-align: bottom;
    }
    .warning-icon-header {
        font-size: 18px;
        vertical-align: bottom;
    }
</style>